import React, { ReactElement } from 'react';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';

// Modules
import { isArray } from 'lodash';
import { classList } from '../../util/util';

interface ITableTabs {
  children: ReactElement | ReactElement[];
  updateYear?: (year: number, type: number) => void;
  defaultTab?: number;
}

const TableTabs = (props: ITableTabs) => {
  const { children, defaultTab, updateYear } = props;

  const tabTitles = titleChildren => {
    if (isArray(titleChildren)) {
      return titleChildren
        /*
         * Typescript does not allow for null JSX returns.
         * Conditional rendering must return empty React.Fragments instead.
         * We need to filter out the `<></>` returns from BassTabs conditional jsx or they will affect child tab rendering.
         * They're also filtered in tabPanels() below.
         */
        .filter((child) => child.type !== React.Fragment)
        .map((child, index) => {
          return (
            <Tab
              key={index + child.props.tabLabel}
              className={classList('react-tabs__tab', child.props.tabClass)}
            >
              {child.props.tabLabel}
            </Tab>
          );
        });
    }
    return <Tab>{titleChildren.props.tabLabel}</Tab>;
  };

  const tabPanels = panelChildren => {
    if (isArray(panelChildren)) {
      return panelChildren
        .filter((child) => child.type !== React.Fragment)
        .map((child, index) => {
          return <TabPanel key={index}>{child}</TabPanel>;
        });
    }
    return <TabPanel>{panelChildren}</TabPanel>;
  };

  return (
    <>
      <Tabs
        {...(defaultTab === 0 ? {selectedIndex: 0} : {selectedIndex: defaultTab})}
        /* tslint:disable:no-empty */
        onSelect={updateYear ? (index) => updateYear(0, index) : () => {}}
      >
        <TabList>{tabTitles(children)}</TabList>
        {tabPanels(children)}
      </Tabs>
    </>
  );
};

export default TableTabs;
